import React, { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Footer from "../../core/common/Footer";
import SearchableSelect from "../../core/common/SearchableSelect";
import { roleNameOptions } from "../../core/data/js/common-data";

const RoleManagement = () => {
  const [showGuide, setShowGuide] = useState<boolean>(true);
  const [selectedRole, setSelectedRole] = useState("");

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Role Management</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.superAdminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Account Activation</li>
                <li className="breadcrumb-item active">Role Management</li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2">
            <CollapseHeader />
          </div>
        </div>
        {/* <GuideContainer
          showGuide={showGuide}
          handleClick={() => setShowGuide((prev) => !prev)}
        /> */}

        <div className="d-flex justify-content-end gap-2 align-items-center mt-3">
          <button
            className="btn border bg-white px-3"
            onClick={() => setShowGuide((prev) => !prev)}
          >
            <i className="ti ti-info-circle-filled fs-16"></i> Guide
          </button>
        </div>

        {showGuide && (
          <div
            style={{
              overflow: "hidden",
              maxHeight: showGuide ? "500px" : "0px",
              transition: "all 0.4s ease",
            }}
          >
            {/* Top Arrow */}
            <div className="text-end pe-3">
              <i
                className="ti ti-triangle-inverted-filled"
                style={{
                  fontSize: "22px",
                  color: "#cfcfcf",
                  lineHeight: 0,
                }}
              ></i>
            </div>

            {/* Guide Box */}
            <div
              className="card border-0 shadow-sm"
              style={{
                borderRadius: "4px",
              }}
            >
              <div className="card-body position-relative p-4">
                {/* Close Button */}
                <div className="position-absolute top-0 end-0 mt-3 me-3">
                  <i
                    className="ti ti-x"
                    style={{
                      background: "#6c757d",
                      color: "#fff",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      fontSize: "12px",
                      cursor: "pointer",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    onClick={() => setShowGuide(false)}
                  ></i>
                </div>

                {/* Heading */}
                <h5 className="fw-bold mb-3">Role Management</h5>

                {/* Paragraph */}
                <p className="mb-3 text-muted" style={{ lineHeight: "1.7" }}>
                  This tab is to be used to modify the user`s access level. Each
                  action/access level can be defined with a pre-set role name.
                  The roles to the user need to be assigned with the USER Role
                  tab.
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Table  */}
        <div className="card mt-3 shadow-sm border-0">
          {/* Header
          <div className="card-header bg-white border-bottom">
            <h4 className="card-title mb-0 text-center fw-bold">
              Role Management
            </h4>
          </div> */}

          {/* Body */}
          <div className="card-body">
            {/* Role Select */}
            <div className="row">
              <div className="col-md-6">
                <SearchableSelect
                  label="Role Name"
                  name="riskMatrix"
                  value={selectedRole}
                  options={roleNameOptions}
                  onChange={(name, value) => setSelectedRole(value)}
                  hasRowGrid={false}
                  // error={errors?.package}
                  required
                />
              </div>
            </div>

            {/* Routes Section */}
            <div className="card mt-4 border">
              <div className="card-body">
                {/* Table Header */}
                <div className="row fw-bold text-dark border-bottom pb-2 mb-3">
                  <div className="col-6">Routes</div>

                  <div className="col-6 text-end">Active / Inactive</div>
                </div>

                {/* Example Rows */}
                <div className="row align-items-center py-2">
                  <div className="col-6">Place Order</div>

                  <div className="col-6 text-end">Active</div>
                </div>

                {/* Invite Applicant */}
                <div className="border rounded p-3 mb-4">
                  <div className="row fw-bold text-dark border-bottom pb-2 mb-3">
                    <div className="col-6">Invite Applicant</div>
                    <div className="col-6 text-center">
                      <span className="badge bg-success">Active</span>
                    </div>
                  </div>

                  <div className="d-flex flex-column gap-3">
                    <div className="row align-items-center border-bottom pb-2">
                      <div className="col-6">Single Invite</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-success">Active</span>
                      </div>
                    </div>

                    <div className="row align-items-center">
                      <div className="col-6">Bulk Invite</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-success">Active</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* HR Form Submission */}
                <div className="border rounded p-3 mb-4">
                  <div className="row fw-bold text-dark border-bottom pb-2 mb-3">
                    <div className="col-6">HR Form Submission</div>
                    <div className="col-6 text-center">
                      <span className="badge bg-success">Active</span>
                    </div>
                  </div>

                  <div className="d-flex flex-column gap-3">
                    <div className="row align-items-center border-bottom pb-2">
                      <div className="col-6">Scan Copy</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-success">Active</span>
                      </div>
                    </div>

                    <div className="row align-items-center border-bottom pb-2">
                      <div className="col-6">Online Form</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-success">Active</span>
                      </div>
                    </div>

                    <div className="row align-items-center border-bottom pb-2">
                      <div className="col-6">Bulk</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-success">Active</span>
                      </div>
                    </div>

                    <div className="row align-items-center border-bottom pb-2">
                      <div className="col-6">Custom Bulk</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-success">Active</span>
                      </div>
                    </div>

                    <div className="row align-items-center">
                      <div className="col-6">Custom Case Bulk</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-success">Active</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bulk Package */}
                <div className="border rounded p-3 mb-4">
                  <div className="row align-items-center border-bottom pb-2">
                    <div className="col-6 fw-bold">Bulk Package</div>

                    <div className="col-6 text-center">
                      <span className="badge bg-danger">Inactive</span>
                    </div>
                  </div>
                  <div className="row align-items-center pt-2">
                    <div className="col-6 fw-bold">Blue Collar Check</div>

                    <div className="col-6 text-center">
                      <span className="badge bg-success">Active</span>
                    </div>
                  </div>
                </div>

                {/* Blue Collar Check */}
                <div className="border rounded p-3">
                  <div className="d-flex flex-column gap-3">
                    <div className="row align-items-center border-bottom pb-2">
                      <div className="col-6">New</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-danger">Inactive</span>
                      </div>
                    </div>

                    <div className="row align-items-center border-bottom pb-2">
                      <div className="col-6">Pending</div>

                      <div className="col-6 text-center">
                        <span className="badge bg-danger">Inactive</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer Button */}
            {/* <div className="mt-4 text-end">
              <button className="btn btn-primary px-4">Save Role</button>
            </div> */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RoleManagement;
